
import $ from 'jquery'; 

let recaptchaPromise = null;

// Debounce function
export function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this,
        args = arguments;
    let later = function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
}

// Kill event
export function kill(e) {
  if (!e) {
    return;
  }
  if (e.preventDefault) {

    e.preventDefault();
  }
  if (e.stopImmediatePropagation) {

    e.stopImmediatePropagation();
  }
  if (e.stopPropagation) {
    e.stopPropagation();
  }
}

// Get transform
export function getTransform(obj) {
  // Ensure jQuery is available if needed
  let transformMatrix = obj.css('-webkit-transform') || obj.css('-moz-transform') || obj.css('-ms-transform') || obj.css('-o-transform') || obj.css('transform'),
      matrix = transformMatrix.replace(/[^0-9\-.,]/g, '').split(','),
      x = matrix[12] || matrix[4], // translate x
      y = matrix[13] || matrix[5]; // translate y

  return { x: x, y: y };
}

// Detect tablet
export function isTablet() {
  return $(window).width() <= 1024;
}

// Detect mobile
export function isMobile() {
  return $(window).width() <= 768;
}

// Detect desktop Safari
export function detectDesktopSafari() {
  return window.safari !== undefined;
}

// Detect IE
export function detectIE() {
  let ua = window.navigator.userAgent,
      msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  let trident = ua.indexOf('Trident/');
  if (trident > 0) {
    let rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  let edge = ua.indexOf('Edge/');
  if (edge > 0) {
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  return false;
}

// Convert image to SVG
export function imgToSvg(item, sideboard, cb) {
  // Ensure jQuery is available if needed
  let $img = $(item),
      imgClass = $img.attr('class'),
      imgStyle = $img.attr('style'),
      imgURL = $img.attr('src'),
      ie = detectIE();

  $.get(imgURL, function(data) {
    let $svg = $(data).find('svg');
    if (typeof imgClass !== 'undefined') {
      $svg = $svg.attr('class', imgClass);
    }
    if (typeof imgStyle !== 'undefined') {
      $svg = $svg.attr('style', imgStyle);
    }
    $svg = $svg.removeAttr('xmlns:a');
    if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
      $svg.attr('viewBox', `0 0 ${$svg.attr('height')} ${$svg.attr('width')}`);
    }
    let scale = $('.mainboard .content').width() / 840,
        vb = $svg.attr('viewBox').split(/\s+|,/);
    $svg.data('width', vb[2]);
    if (ie && ie < 12) {
      $svg.attr('preserveAspectRatio', 'none');
      $svg.attr('width', vb[2]);
      $svg.attr('height', vb[3]);
    }
    $svg.attr('source', imgURL);
    $img.replaceWith($svg);
    cb();
  }, 'xml');
}

// Convert component to hex
export function componentToHex(c) {
  let hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

// Convert RGB to hex
export function rgbToHex(r, g, b) {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

// Get URL parameters
export function getUrlParams() {
  let params = {};
  let query = window.location.search.substring(1).split('&');
  for (let i = 0, max = query.length; i < max; i++) {
    if (query[i] === '') { // check for trailing & with no param
      continue;
    }
    let param = query[i].split('=');
    let key = decodeURIComponent(param[0]);
    let value = decodeURIComponent(param[1] || '');
    params[key] = value;
  }
  return params;
}

// Ensure reCAPTCHA
export function ensureRecaptcha() {
  if (recaptchaPromise === null) {
    let deferred = new $.Deferred();
    recaptchaPromise = deferred.promise();
    $.ajaxSetup({
      cache: true
    });
    window.recaptchaReady = function() {
      deferred.resolve(grecaptcha);
    };
    $.getScript('https://www.google.com/recaptcha/api.js?render=explicit&onload=recaptchaReady');
  }
  // console.log(recaptchaPromise);
  return recaptchaPromise;
}

// Render reCAPTCHA
export function renderRecaptcha($element, callback) {
  let deferred = new $.Deferred();
  if (!$element || $element.length === 0) {
    deferred.reject();
    return deferred.promise();
  }
  callback = callback || $.noop;
  ensureRecaptcha().done(function(grecaptcha) {
    let id = grecaptcha.render($element[0], {
      sitekey: $element.data('sitekey'),
      callback: callback
    });
    deferred.resolve(grecaptcha, id);
  });
  // console.log(deferred.promise());
  return deferred.promise();
}
